export const selectPipelineStages = ({ pipelineStages }) => pipelineStages
export const selectIspipelineStagesLoading = ({ pipelineStages: { isLoading } }) => isLoading
